/**
 * <AttendanceTable 
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import ReactHTMLTableToExcel from 'vendor/react-html-table-to-excel';
import moment from 'moment'
import classnames from 'classnames'
import teacherAttendanceRecord from 'controllers/teacher/teacherAttendanceRecord'
import studentAttendanceRecord from 'controllers/student/studentAttendanceRecord'
import AttendanceLessonTime from 'containers/pages/Teacher/Attendance/AttendanceLessonTime'
import AttendanceStatus from 'containers/pages/Teacher/Attendance/AttendanceStatus'
import AttendTime from 'containers/pages/Teacher/Attendance/AttendTime'
import Loading from 'components/UI/Loading';
import {CSVLink} from 'react-csv';
import {
  Table,
} from 'components/UI'
import locale from '../locale.js';
import momentDurationFormatSetup from 'moment-duration-format'
momentDurationFormatSetup(moment)

class AttendanceTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attendanceList: [],
      attendanceDetail: {},
      doneFetching: false,
      downloaded: false      
    }
    this.csvAttendanceList = [];
    this.fetchAttendance = this.fetchAttendance.bind(this);
  }

  componentWillMount() {
    this.fetchAttendance();
  }
  fetchAttendanceSummary(){
    const {state, attendance} = this.props;
    const {
      total_counted_amount,
      total_counted_duration,
      total_normal_amount,
      total_normal_duration,
      total_late_amount,
      total_late_duration,
      total_retroactive_amount,
      total_absent_amount,
      total_absent_duration,
      total_leave_amount,
      total_leave_duration,
      total_truancy_amount,
      total_truancy_duration,
      total_unchecked_amount,
      total_unchecked_duration
    } = this.state.attendanceDetail;

    this.csvAttendanceList[0]['']  = '                                 ';
    this.csvAttendanceList[0][__('Total Attended Count', 'teacherAttendance')] = total_counted_amount;
    this.csvAttendanceList[0][__('Total Attended Duration', 'teacherAttendance')] = moment.duration(Number(total_counted_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h';
    this.csvAttendanceList[0][__('On-Time Count', 'teacherAttendance')] = total_normal_amount;
    this.csvAttendanceList[0][__('On-Time Duration', 'teacherAttendance')] = moment.duration(Number(total_normal_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h';    
    this.csvAttendanceList[0][__('Late Count','teacherAttendance')] = total_late_amount;
    this.csvAttendanceList[0][__('Late Duration','teacherAttendance')] = moment.duration(Number(total_late_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h';
    this.csvAttendanceList[0][__('Makeup Count','teacherAttendance')] = total_retroactive_amount;
    this.csvAttendanceList[0][__('Total Unattended Count','teacherAttendance')] = total_absent_amount;
    this.csvAttendanceList[0][__('Total Unattended Duration','teacherAttendance')] = moment.duration(Number(total_absent_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h';
    this.csvAttendanceList[0][__('Absent (with excuse) Count','teacherAttendance')] = total_leave_amount;
    this.csvAttendanceList[0][__('Absent (with excuse) Duration','teacherAttendance')] = moment.duration(Number(total_leave_duration), 'minutes').format('h[h] m[m]', {trim: 'all'}) || '0h';
    this.csvAttendanceList[0][__('Absent (without notice) Count','teacherAttendance')] = total_truancy_amount;
    this.csvAttendanceList[0][__('Absent (without notice) Duration','teacherAttendance')] = moment.duration(Number(total_truancy_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h';
    if(state === 'student'){
      this.csvAttendanceList[0][__('Unchecked Count','teacherAttendance')] = moment.duration(Number(total_unchecked_amount), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h';
      this.csvAttendanceList[0][__('Unchecked Duration','teacherAttendance')] = moment.duration(Number(total_unchecked_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h';
    }
    if(state==='teacher'){
      this.csvAttendanceList[0][__('Total Salary:', 'teacherAttendance')] = '$'+attendance.totalSalary;      
    }
  }
  fetchAttendance() {
    const { state } = this.props    
    this.currentPage = 1;
    if(state==='teacher'){
      this.fetchTeacherAttendance(()=>{
        this.fetchAttendanceSummary();
        this.setState({doneFetching: true})
      });
    }else {
      this.fetchStudentAttendance(()=>{
        this.fetchAttendanceSummary();
        this.setState({doneFetching: true})
      });
    }
  }
  formatLessonTime(attendance) {
    const {lesson_start_datetime, lesson_end_datetime, check_in_state} = attendance;
    let lessonTime;
    lessonTime = moment(lesson_start_datetime).format(__('MMM DD, YYYY', 'dateFormat')) + ' ' + moment(lesson_start_datetime).format('HH:mm') + ' - ' + moment(lesson_end_datetime).format('HH:mm');
    if(check_in_state === 1) {
      lessonTime = lessonTime + ' ' + moment.duration(moment(lesson_end_datetime) - moment(lesson_start_datetime)).format('h [h] m [m]', {trim: 'all'});
    }
    return lessonTime;
  }
  formatAttendTime(attendance) {
    const {lesson_start_datetime, check_in_datetime} = attendance;    
    let attendTime;
    if(!check_in_datetime){
      attendTime = '––';
    } else if (moment(lesson_start_datetime).format('YYYY-MM-DD') == moment(check_in_datetime).format('YYYY-MM-DD')){
      attendTime = moment(check_in_datetime).format('HH:mm');
    } else {
      attendTime = moment(check_in_datetime).format(__('MMM DD, YYYY', 'dateFormat'))+' '+ moment(check_in_datetime).format('HH:mm');
    }
    return attendTime;
  }
  getAttendanceStatus(attendance) {
    const { state } = this.props    
    let {check_in_state, lesson_start_datetime, lesson_end_datetime, check_in_datetime} = attendance;
    
    if(check_in_state == 0){
      if(state === 'student'){
        return __('Unchecked', locale)
      }else {
        return __('Absent (without notice)', locale)
      }
    }else if(check_in_state == 1){
      if(moment(check_in_datetime).isBefore(lesson_start_datetime)){
        return __('Attended', locale);
      }else if ((moment(check_in_datetime).isBetween(moment(lesson_start_datetime), moment(lesson_end_datetime), null, '[]'))){
        return __('Late', locale);
      }else {
        return __('Make Up', locale);
      }
    } else if (check_in_state == 2){
      return __('Absent (with excuse)', locale)
    } else if (check_in_state == 3){
      return __('Late', locale)
    } else if (check_in_state == 4){
      return __('Absent (without notice)', locale);
    } else if (check_in_state == 5){
      return __('Make Up', locale);
    }
  }
  fetchTeacherAttendance(done) {
    const { id, attendanceInfo } = this.props
    teacherAttendanceRecord(id, {
      ...attendanceInfo,
      amount_per_page: 50,
      current_page_number: this.currentPage
    }).then((result)=>{
      this.setState({attendanceList: this.state.attendanceList.concat(result.result_list), attendanceDetail: result}, ()=>{
        if(this.state.attendanceList.length>0) {
          this.csvAttendanceList = this.state.attendanceList.map((attendance)=>{
            let csvAttendance = {};
            csvAttendance[__('Class Name', 'teacherAttendance')] = attendance.class_name;
            csvAttendance[__('Lesson', 'teacherAttendance')] = __('Lesson', 'teacherAttendance')+' '+attendance.lesson_index;
            csvAttendance[__('Lesson Time', 'teacherAttendance')] = this.formatLessonTime(attendance);
            csvAttendance[__('Attend Time', 'teacherAttendance')] = this.formatAttendTime(attendance);
            csvAttendance[__('Status', 'teacherAttendance')] = this.getAttendanceStatus(attendance);
            return csvAttendance;
          })
        }
      })          
      if(this.currentPage>=result.page_amount) {
        done();
        return;
      }
      this.currentPage++;          
      this.fetchTeacherAttendance(done);
    })
  }
  fetchStudentAttendance(done) {
    const { id, attendanceInfo } = this.props
    studentAttendanceRecord(id, {
      ...attendanceInfo,
      amount_per_page: 50,
      current_page_number: this.currentPage
    }).then((result)=>{
      this.setState({attendanceList: this.state.attendanceList.concat(result.result_list), attendanceDetail: result}, ()=>{
        if(this.state.attendanceList.length>0) {
          this.csvAttendanceList = this.state.attendanceList.map((attendance)=>{
            let csvAttendance = {};
            csvAttendance[__('Class Name', 'teacherAttendance')] = attendance.class_name;
            csvAttendance[__('Lesson', 'teacherAttendance')] = __('Lesson', 'teacherAttendance')+' '+attendance.lesson_index;
            csvAttendance[__('Lesson Time', 'teacherAttendance')] = this.formatLessonTime(attendance);
            csvAttendance[__('Attend Time', 'teacherAttendance')] = this.formatAttendTime(attendance);
            csvAttendance[__('Status', 'teacherAttendance')] = this.getAttendanceStatus(attendance);
            return csvAttendance;
          })
        }
      })          
      if(this.currentPage>=result.page_amount) {
        done();
        return;
      }
      this.currentPage++;          
      this.fetchStudentAttendance(done);
    })
  }
  renderDownloadBtn() {
    const {format} = this.props;

    if(!this.state.doneFetching) {
      return (
        <div style={{height:40, textAlign: 'center'}}>
          <Loading />
        </div>
      );
    }else if (!this.state.downloaded) {
      return(
        <span className="downloadBtnWrapper" onClick={()=>{this.setState({downloaded: true})}}>
          {
            format === 'excel' && 
            <ReactHTMLTableToExcel
              className={'btn btn-primary download-btn'}
              table='attendance-table'
              filename={ this.props.state === 'teacher'? 'Attendance Record for '+ this.state.attendanceDetail.teacher_name : 'Attendance Record for '+ this.state.attendanceDetail.student_name}
              sheet='attendance_table'
              buttonText={__('Download', locale)}
            />
          }
          {
            format === 'csv' && 
            <CSVLink 
              data={this.csvAttendanceList} 
              filename={this.props.state === 'teacher'? 'Attendance Record for '+ this.state.attendanceDetail.teacher_name + '.csv' : 'Attendance Record for '+ this.state.attendanceDetail.student_name + '.csv'} 
              className="btn btn-primary download-btn"
              target='_self'>
              {__('Download', locale)}
            </CSVLink>            
          }

        </span>
      )
    } else if (this.state.downloaded) {
      return(
        <div>
          <h3 className='download-success-text'>{__('Download Successfully!', locale)}</h3>
          {
            format === 'excel' && 
            <ReactHTMLTableToExcel
              className={'btn-link redownload-btn'}
              table='attendance-table'
              filename={ this.props.state === 'teacher'? 'Attendance Record for '+ this.state.attendanceDetail.teacher_name : 'Attendance Record for '+ this.state.attendanceDetail.student_name}
              sheet='attendance_table'
              buttonText={__('Redownload', locale)}
            />
          }          
          {
            format === 'csv' && 
            <CSVLink 
              data={this.csvAttendanceList} 
              filename={this.props.state === 'teacher'? 'Attendance Record for '+ this.state.attendanceDetail.teacher_name + '.csv' : 'Attendance Record for '+ this.state.attendanceDetail.student_name + '.csv'} 
              className="btn-link redownload-btn"
              target='_self'>
              {__('Redownload', locale)}
            </CSVLink>            
          }

        </div>
      )
    }else {
      return null;
    }

  }
  render() {
    const { state, attendanceInfo } = this.props;
    const {
      total_counted_amount,
      total_counted_duration,
      total_normal_amount,
      total_normal_duration,
      total_late_amount,
      total_late_duration,
      total_retroactive_amount,
      total_absent_amount,
      total_absent_duration,
      total_leave_amount,
      total_leave_duration,
      total_truancy_amount,
      total_truancy_duration,
      total_unchecked_amount,
      total_unchecked_duration,
      teacher_name,
      student_name
    } = this.state.attendanceDetail;
    const fields = [
      {
        name: 'class_name',
        title: __('Class Name', 'teacherAttendance'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "15%"
            }
          }
        }
      },
      {
        name: 'lesson_index',
        title: __('Lesson', 'teacherAttendance'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "8%"
            }
          }
        },        
        getTdContent: ({ trData })=>{
          return __('Lesson', 'teacherAttendance')+' '+trData.lesson_index
        },
      },
      {
        name: 'lesson_time',
        title: __('Lesson Time', 'teacherAttendance'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "20%"
            }
          }
        },
        getTdContent: ({ trData: attendenceInfo })=>{
          return <AttendanceLessonTime attendenceInfo={attendenceInfo} />
        },
      },
      {
        name: 'check_in_datetime',
        title: __('Attend Time', 'teacherAttendance'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "15%"
            }
          }
        },
        getTdContent: ({ trData: attendenceInfo })=>{
          return <AttendTime attendenceInfo={attendenceInfo} />
        },
      },
      {
        name: 'state',
        title: __('Status', 'teacherAttendance'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "7%"
            }
          }
        },
        getTdContent: ({ trData: attendenceInfo })=>{
          return <AttendanceStatus attendenceInfo={attendenceInfo} currentRole={this.props.state}/>
        },
      },
    ]
    return (
      <div className='AttendanceTable'>
        {this.renderDownloadBtn()}
        <table id='attendance-table' style={{width:'100%', display: 'none'}}>
          <tbody>
            <table>
              <tr style={{ fontSize: 15 }}>
                { state == 'teacher' && <th>{teacher_name}</th>}
                { state == 'student' && <th>{student_name}</th>}
                <th colSpan="2">
                  {attendanceInfo.start_date} - {attendanceInfo.end_date}
                </th>
              </tr>
              <tr>
              </tr>
              <tr>
                <th colSpan="7" style={{color:'#fff', backgroundColor:'#3b67bc', fontSize: 14}}>
                  {__('Attendance Overview', 'teacherAttendance')}
                </th>
              </tr>
              <tr>
                <th>
                  {__('Total Attended Count & Duration', 'teacherAttendance')}
                </th>
                <th>
                  {__('On Time Count & Duration','teacherAttendance')}
                </th>
                <th>
                  {__('Late Count & Duration','teacherAttendance')}
                </th>
                <th>
                  {__('Makeup Count','teacherAttendance')}
                </th>
                <th>
                  {__('Total Unattended Count & Duration','teacherAttendance')}
                </th>
                <th>
                  {__('Absent (with excuse) Count & Duration','teacherAttendance')}
                </th>
                <th>
                  {__('Absent (without notice) Count & Duration','teacherAttendance')}
                </th>
                {
                  state == 'student' &&
                  <th>
                    {__('Unchecked Count & Duration','teacherAttendance')}
                  </th>
                }
              </tr>
              <tr style={{textAlign:'center'}}>
                <td>{total_counted_amount}</td>
                <td>{total_normal_amount}</td>
                <td>{total_late_amount}</td>
                <td>{total_retroactive_amount}</td>
                <td>{total_absent_amount}</td>
                <td>{total_leave_amount}</td>
                <td>{total_truancy_amount}</td>
                {
                  state == 'student' &&
                  <td>{total_unchecked_amount}</td>
                }
              </tr>
              <tr style={{textAlign:'center'}}>
                <td>{moment.duration(Number(total_counted_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h'}</td>
                <td>{moment.duration(Number(total_normal_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h'}</td>
                <td>{moment.duration(Number(total_late_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h'}</td>
                <td></td>
                <td>{moment.duration(Number(total_absent_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h'}</td>
                <td>{moment.duration(Number(total_leave_duration), 'minutes').format('h[h] m[m]', {trim: 'all'}) || '0h'}</td>
                <td>{moment.duration(Number(total_truancy_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h'}</td>
                {
                  state == 'student' &&
                  <td>{moment.duration(Number(total_unchecked_duration), 'minutes').format('h [h] m [m]', {trim: 'all'}) || '0h'}</td>
                }
              </tr>
              <tr>
              </tr>
              {
                state == 'teacher' &&
                <tr>
                  {/* <td style={{ fontSize: 15}}>
                    {__('Hourly Rate:', 'teacherAttendance')}
                  </td>
                  <td style={{ color: '#b5becc'}}>
                    {__('Please enter value', 'teacherAttendance')}
                  </td>
                  <td>
                  </td> */}
                  <td style={{ fontSize: 15}}>
                    {__('Total Salary:', 'teacherAttendance')}
                  </td>
                  <td style={{ color: '#FCAF3D', fontSize: 18 }}>
                    ${this.props.attendance.totalSalary}
                  </td>
                </tr>
              }
              <tr>
              </tr>
              <tr>
                <th colSpan="7" style={{color:'#fff', backgroundColor:'#3b67bc', fontSize: 14}}>
                  {__('Attendance Detail', 'teacherAttendance')}
                </th>
              </tr>
            </table>
          </tbody>
          <tbody>
            <td>
              <Table
                data={this.state.attendanceList}
                fields={fields}
                crqassName='registration-table'
                settingThTitle={__('Settings', 'class')}
                settingWidth={'15%'}
                useMultiSelection={false}
                oneSettingPerRow={false}
                dropdownGuideWidth={160}
                dropdownGuideHeight={228}
								usePagination={false}
              />
            </td>
          </tbody>
        </table>
      </div>
    )
  }
}

export default AttendanceTable;



// WEBPACK FOOTER //
// ./src/template/Modals/Export/table/Attendance.js